import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
export const VaultColoredDot = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  const t1 = color || "transparent";
  let t2;
  if ($[0] !== t1) {
    t2 = <Box padding="4px"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill={t1} /></svg></Box>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};